import { AuditEntity } from "@app/common";
import { ExpansionStage } from "@app/fiber-management";
import { Column, Display, Table } from "@messaia/cdk";

@Table({
    endpoint: 'pidatahistory',
    addable: false,
    editable: false,
    detailsTemplate: `<div [innerHtml]="notice"></div>`
})
export class PiDataHistory extends AuditEntity {
    @Column()
    @Display($localize`:@@location:Location`)
    locationId: string;

    @Column({ showGtMd: true })
    @Display($localize`:@@serial:Serial`)
    serial: string;

    @Column({ disable: (_: any) => true, showGtMd: true })
    @Display($localize`:@@valid:Valid`)
    valid: boolean;

    @Column({ contentLength: 30, showGtMd: true })
    @Display($localize`:@@notice:Notice`)
    notice: string;

    @Column({ showGtXl: true })
    @Display($localize`:@@fileName:File name`)
    sourceFile: string;

    address1: string;
    address2: string;
    address3: string;
    postalCode: string;
    city: string;
    district: string;
    gEENE3: string;
    gEENE4: string;
    residentialUnits: number | null;
    apSalutation: string;
    apName: string;
    apFirstName: string;
    apPhoneNumber1: string;
    apPhoneNumber2: string;
    apEmail: string;
    apAddress1: string;
    apAddress2: string;
    apPostalCode: string;
    apCity: string;
    apManagementSalutation: string;
    apManagementName: string;
    apManagementFirstName: string;
    apManagementPhoneNumber1: string;
    apManagementPhoneNumber2: string;
    apManagementEmail: string;
    apManagementAddress1: string;
    apManagementAddress2: string;
    apManagementPostalCode: string;
    apManagementCity: string;
    connectionType: string;
    nE3PlanDate: string;
    nE4PlanDate: string;
    aplAddress1: string;
    aplAddress2: string;
    aplAddress3: string;
    aplPostalCode: string;
    aplCity: string;
    expansionStage: ExpansionStage | null;
    areaPopId: string;
    splitterBay: string;
    oDFPortId: string;
    aPLPortId: string;
    gfTaId: string;
    tvSupply: string;
    tvExpansionStage: string;
    splitterName: string;
    splitterOutput: string;
    oNTType: string;
    oNTSerialNumber: string;
    passthrough: string;
    bAY: string;
    p2POLT: string;
    p2PMAU: string;
    p2POLTPort: string;
    p2PIADType: string;
}